import React from 'react';
import classes from "./Login.module.css";
import { connect } from 'react-redux';
import { Row, Col, Form, Icon, Input, Button, Checkbox, message } from 'antd';
import { app_SET } from '../redux/actions';
import { AxiosServer } from '../utils';
import { Link } from 'react-router-dom';
import './Login.css';
import djlogo from './djlogo.png';

// 背景组件
import Background from "../components/Background/Background.js";

class LoginBase extends React.Component {

    render() {
        const { app_set } = this.props;
        const { getFieldDecorator } = this.props.form;

        // 清空历史
        sessionStorage.removeItem('user_name');
        sessionStorage.removeItem('roleid');

        const handleSubmit = (e) => {
            e.preventDefault();

            this.props.form.validateFields((err, values) => {
                // 可以对values.password 进行加密处理，当然改了规则后，需要后端同步修改。目前未加密
                if (!values || values.user_name === undefined || values.password === undefined) {
                    message.error('Username and Password is required. ', 2);
                } else {
                    this.logining = true;
                    message.info('登陆中')

                    values.password = new Buffer.from(values.password + '@123').toString('base64')
                    let Axios = new AxiosServer();
                    Axios.post('/api/login', values).then(res => {
                        message.destroy()
                        //登陆结果判断
                        if (!res.data.status || res.data.status === 'failed') {
                            let info = res.data.msg ? res.data.msg : 'login failed'
                            message.error(info)
                        } else {

                            if (!res.data.data.roleid) {
                                message.error('无权限或配置权限不正确')
                                return;
                            }
                            let token = res.headers['token'];
                            app_set({ loginData: res.data.data, token: token }) // 由于刷新会重置数据，所以实际应用中并不实用，改为本地session存储。             
                            message.success('login OK')
                            //可选动作，写入sessionStorage.，以便保持长久在线                
                            sessionStorage.setItem('token', token);
                            sessionStorage.setItem('id', res.data.data.id);
                            sessionStorage.setItem('user_name', res.data.data.user_name);
                            sessionStorage.setItem('roleid', res.data.data.roleid);
                            sessionStorage.setItem('groupid', res.data.data.groupid);
                            this.props.history.push('/');

                        }

                    }).catch(err => {
                        console.log(err);
                        message.error(err.message)

                    })
                }
            });
        }

        return (
            <>
                <div className="main-w3layouts wrapper">
                    <Row style={{ marginTop: '20px', marginLeft: '10px' }}><img src={djlogo} width='200px' /></Row>
                    <div className={classes.content}>


                        <div className={classes.loginBox}>
                            <br /><h1 >
                                <font color='#DCDCDC'>金掌柜系统 </font>
                            </h1>        <br />
                            <div style={{ width: '280px' }}>
                                <Form onSubmit={handleSubmit} className="login-form" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Form.Item >
                                        {getFieldDecorator('user_name', {
                                            rules: [{ required: true, message: 'Please input your username!' }],
                                        })(
                                            <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" />
                                        )}
                                    </Form.Item>
                                    <Form.Item>
                                        {getFieldDecorator('password', {
                                            rules: [{ required: true, message: 'Please input your Password!' }],
                                        })(
                                            <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
                                        )}
                                    </Form.Item>
                                    <Form.Item>
                                        {getFieldDecorator('remember', {
                                            valuePropName: 'checked',
                                            initialValue: true,
                                        })(
                                            <Checkbox>Remember me</Checkbox>
                                        )}
                                        <span style={{ float: 'right' }} ><Link to='/error' >Forgot password</Link></span>
                                        <div className={classes.loginAndRegis}>
                                            <Button type="primary" htmlType="submit" className="login-form-button">
                                                Log in
                                            </Button>
                                            <span style={{ float: 'right' }} ><Link to='/error' >register now!</Link></span>
                                        </div>
                                    </Form.Item>
                                </Form> </div>
                        </div>
                    </div>

                </div>
                {/** 背景组件会自动应用到 body 下 */}
                <Background></Background>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        app: state.appReducer
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        app_set: (value) => dispatch(app_SET(value))
    }
}

const LoginRender = Form.create({ name: 'form' })(LoginBase);
const Login = connect(mapStateToProps, mapDispatchToProps)(LoginRender);

export default Login;
